export const BIRDVIEW_CHART_CARD_SKELETON_BARS_COUNT = 5

export const BIRDVIEW_CHART_CARD_SKELETON_COLUMNS_COUNT = 4

export const BIRDVIEW_CHART_CARD_SKELETON_LEGEND_COUNT = 3
